import React from 'react';
import { Navigate } from 'react-router-dom';
import SEO from '../components/common/SEO';
import SignupForm from '../components/SignupForm';
import { useAuth } from '../contexts/AuthContext';

const SignupPage: React.FC = () => {
  const { isAuthenticated, loading } = useAuth();

  // Show loading spinner while checking authentication status
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100" style={{ marginTop: '100px' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // Redirect to home if already authenticated
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="signup-page" style={{ marginTop: '100px' }}>
      <SEO 
        title="Sign Up | Quicket"
        description="Create a new Quicket account to start buying tickets and managing your events."
      />
      <SignupForm />
    </div>
  );
};

export default SignupPage;
